import { Pipe, PipeTransform } from "@angular/core";
import { HelperService } from "src/app/services/helper.service";

@Pipe({
    name: 'enumKeys',
    standalone: false
})
export class EnumKeysPipe implements PipeTransform {

  constructor(
    private helperService: HelperService,
  ){
  }
  
  transform(value: any) : any {
    return this.helperService.convertEnumToArray(value);
  }
}

